import { render, staticRenderFns } from "./tenderoVer.vue?vue&type=template&id=305fd512&scoped=true"
import script from "./tenderoVer.vue?vue&type=script&lang=js"
export * from "./tenderoVer.vue?vue&type=script&lang=js"
import style0 from "./tenderoVer.vue?vue&type=style&index=0&id=305fd512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305fd512",
  null
  
)

export default component.exports